var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconlyBoldMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.667,
    height: 28.5,
    viewBox: "0 0 31.667 28.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Message",
    "data-name": "Iconly/Bold/Message",
    transform: "translate(-2 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M23.653,0a8.006,8.006,0,0,1,8.013,8h0V20.5a8.008,8.008,0,0,1-8.013,8H8.012A8.006,8.006,0,0,1,0,20.5H0V8A8,8,0,0,1,8.012,0H23.653Zm1.791,8.233a1.2,1.2,0,0,0-.888.317h0l-7.139,5.7a2.48,2.48,0,0,1-3.167,0h0L7.125,8.55a1.21,1.21,0,0,0-1.7,1.694h0l.207.206,7.2,5.621a4.986,4.986,0,0,0,6.189,0h0l7.142-5.716.127-.127a1.225,1.225,0,0,0-.017-1.583A1.331,1.331,0,0,0,25.444,8.233Z",
    transform: "translate(0 0)",
    fill: "#d1a02e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlyBoldMessage);
export default __webpack_public_path__ + "static/media/Iconly-Bold-Message.cee4ff61bc9f7ae21a36fb1596cf532f.svg";
export { ForwardRef as ReactComponent };